document.addEventListener('DOMContentLoaded', function () {
  const glideElements = document.querySelectorAll('.tech-items__slider');

  glideElements.forEach((element) => {
    let glideInstance = null;

    function mountGlide() {
      const slideItems = element.querySelectorAll('.glide__slide');
      if (slideItems.length > 2) {
        glideInstance = new Glide(element, {
          type: 'slider',
          startAt: 0,
          perView: 3,
          gap: 20,
          peek: {
            before: 80,
            after: 80
          },
          breakpoints: {
            1000: {
              perView: 3,
              peek: {
                before: 80,
                after: 80
              }
            },
            740: {
              perView: 2,
              peek: {
                before: 90,
                after: 90
              }
            },
            400: {
              perView: 1,
              peek: {
                before: 70,
                after: 70
              }
            }
          }
        });
        glideInstance.mount();
      } else {
        const el = element.querySelector('.glide__slides');
        element.classList.add('tech-items--static');
        el.classList.add('tech-items__slider--disabled');
      }
    }

    function destroyGlide() {
      if (glideInstance) {
        glideInstance.destroy();
        glideInstance = null;
      }
    }

    function handleResize() {
      if (window.innerWidth > 1000) {
        destroyGlide();
        const slides = element.querySelector('.glide__slides');
        if (!slides.classList.contains('tech-items__slider--disabled')) {
          element.classList.add('tech-items--static');
        }
      } else {
        if (!glideInstance) {
          mountGlide();
        }
        const slides = element.querySelector('.glide__slides');
        if (!slides.classList.contains('tech-items__slider--disabled')) {
          element.classList.remove('tech-items--static');
        }
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    if (window.innerWidth <= 1000) {
      mountGlide();
    }
  });
});
